// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from 'firebase/auth';

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyDIS0KkHtNtJMxE3VMkSzHMyInRJfXoSqg",
  authDomain: "project-cost-faa62.firebaseapp.com",
  projectId: "project-cost-faa62",
  storageBucket: "project-cost-faa62.firebasestorage.app",
  messagingSenderId: "1010113421252",
  appId: "1:1010113421252:web:b449f6831f5f2f3b7e0e91",
  measurementId: "G-930Y0XXDV5"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);

export { db, auth };
